import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import type { SpecialtyOptionsResponse } from '../Types/Responses/SpecialtyResponses'

export default class SpecialtyService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/specialties'
  }

  async getOptions(companyId: number): Promise<SpecialtyOptionsResponse> {
    try {
      const { data } = await request.get<SpecialtyOptionsResponse>(
        this.getCompletePath('/options'),
        {
          companyId
        }
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as especialidades')
    }
  }
}
